/**
 * Import
 * - Libraries
 */
import { connect } from 'react-redux'
import { get } from 'lodash'
/**
 * Import
 * - Store
 */
import { RootState } from '../../../../../store'
/**
 * Import
 * - Actions
 */
import { setStep04c, setStep04cRenewals, resetQuotes } from '../../../../../actions'
/**
 * Import
 * - Page component
 */
import Step04c from '../components/Step04c'

const mapStateToProps = (state: RootState, props: any) => {

    return {
        quote: state.quote,
        fullQuote: get(state.quote, 'full.response.quote', {}),
    }
}

export default connect(
    mapStateToProps,
    {
        setStep04c: setStep04c,
        setStep04cRenewals: setStep04cRenewals,
        resetQuotes: resetQuotes,       
    }
)(Step04c)



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/Policies/MTA/containers/Step04c.tsx